import React, { useState } from 'react'
import ClosingGroup from '../closingGroup'
import { ClosingGroupContainerProps } from '../types'

const ClosingGroupContainer: React.FC<ClosingGroupContainerProps> = ({
  closingOverviewProjection,
  isExpandedAll = true,
  slots,
  onPartyClick,
}) => {
  const {
    grouped_closings: groupedClosings = [],
    grouping_key: groupingKey = '',
  } = closingOverviewProjection
  const [expandedGroups, setExpandedGroups] = useState<Record<string, boolean>>(
    Object.fromEntries(groupedClosings.map(group => [group.key, isExpandedAll]))
  )

  const toggleGroup = (key: string) => {
    setExpandedGroups(prev => ({ ...prev, [key]: !prev[key] }))
  }

  return (
    <>
      {groupedClosings.map(
        ({ key, group_label, closings, computed_aggregations }, index) => (
          <ClosingGroup
            key={key}
            elmId={`closing_group_${index}`}
            groupingKey={groupingKey}
            groupLabel={group_label}
            closings={closings}
            isExpanded={expandedGroups[key] || false}
            onToggle={() => toggleGroup(key)}
            slots={slots}
            onPartyClick={onPartyClick}
            computedAggregations={computed_aggregations}
          />
        )
      )}
    </>
  )
}

export default ClosingGroupContainer
